import { render } from "./WorkAreaSection.vue?vue&type=template&id=5e034b4b"
import script from "./WorkAreaSection.vue?vue&type=script&lang=js"
export * from "./WorkAreaSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__